import { Box, Divider } from '@mui/material';
import { StyledTitle } from '@shared/components/StyledComponents';
import { LiveWebsocketGrid } from '@shared/components/LiveWebsocketGrid';
import { ServerInfo } from '@protos/v2/serverinfo';

export const UserLiveWebsockets = ({ streamInfo }: { streamInfo: ServerInfo }) => {
  return (
    <Box mt={2}>
      <Divider />
      <Box display="flex" flexDirection="row" mt={2} pb="3px">
        <StyledTitle sx={{ flex: 1 }}>Live Websockets</StyledTitle>
      </Box>
      <LiveWebsocketGrid data={streamInfo.live_websockets} height="150px" />
    </Box>
  );
};
